<template>
  <div class="bespread-wrap module-layer4">
    <div class="screen-container">
      <div class="cnt">
        <img src="../../assets/img/layer4/bt.png" class="bt" />
        <div class="role-cnt">
          <swiper
            :options="roleOptions"
            ref="roleOptions"
            @slideChange="roleNavSlideChange"
          >
            <swiper-slide v-for="(iconItem, idx) in roleList" :key="idx">
              <div class="role" :class="'role-' + iconItem.id">
                <img :src="iconItem.info" alt="" srcset="" class="role-info" />
                <img :src="iconItem.roleIdx" alt="" srcset="" class="roleIdx" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <div
            class="swiper-pagination swiper-pagination-role cursor"
            :class="[nextShow ? '' : 'swiperNoSwiping']"
            slot="pagination"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      iconActive: 1,
      roleList: [
        {
          id: 1,
          info: require("../../assets/img/layer4/1-msg.png"),
          roleIdx: require("../../assets/img/layer4/1-role.png")
        },
        {
          id: 2,
          info: require("../../assets/img/layer4/2-msg.png"),
          roleIdx: require("../../assets/img/layer4/2-role.png")
        },
        {
          id: 3,
          info: require("../../assets/img/layer4/3-msg.png"),
          roleIdx: require("../../assets/img/layer4/3-role.png")
        },
        {
          id: 4,
          info: require("../../assets/img/layer4/4-msg.png"),
          roleIdx: require("../../assets/img/layer4/4-role.png")
        }
      ],
      nextShow: true,

      roleOptions: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination-role",
          touchRatio: 1, //解决滑动卡顿
          longSwipesRatio: 0.1,
          threshold: 10, //如果触摸距离小于该值滑块不会被拖动
          followFinger: false,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          clickable: true, // 允许点击小圆点跳转
          autoplayDisableOnInteraction: false,

          renderBullet: function(index, className) {
            switch (index) {
              case 0:
                name = "";
                break;
              case 1:
                name = "";
                break;
              case 2:
                name = "";
              case 3:
                name = "";
              default:
                name = "";
            }
            return (
              '<div class="' +
              className +
              " " +
              className +
              [index] +
              '"><i>' +
              name +
              "</i></div>"
            );
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  methods: {
    roleNavSlideChange() {}
  }
};
</script>
<style lang="scss">
.module-layer4 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer4/bg.png");
  background-position: center;

  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: calc(100% - 250px);
    .cnt {
      width: 100%;
      height: 100%;
      position: relative;

      .bt {
        width: 377px;
        height: auto;
        margin: 2vw 0 0 8vw;
      }
      .role-cnt {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
      // 菜单
      .swiper-slide {
        overflow: hidden;
      }
      .swiper-button-prev:after {
        display: none;
      }

      .swiper-button-next:after {
        display: none;
      }

      .swiper-button-prev {
        background: url("../../assets/img/layer4/prev.png") no-repeat top;
        background-size: 100% 100%;
        width: 18px;
        height: 25px;
        top: 43vw;
        left: 8.5vw;
      }

      .swiper-button-next {
        background: url("../../assets/img/layer4/next.png") no-repeat top;
        background-size: 100% 100%;
        width: 18px;
        height: 25px;
        top: 43vw;
        left: 34vw;
      }
      .role {
        position: relative;
        width: 100%;
        height: 100%;
        .role-info {
          width: 638px;
          height: auto;
          margin: 8vw 0 0 2vw;
        }
      }
      // 每个角色尺寸大小需单独设置
      .roleIdx {
        position: absolute;
        z-index: -1;
      }
      .role-1 .roleIdx {
        width: 1622px;
        height: auto;
        right: -24vw;
        top: -11vw;
      }
      .role-2 .roleIdx {
        width: 1602px;
        height: auto;
        right: -22vw;
        top: -5vw;
      }
      .role-3 .roleIdx {
        width: 1887px;
        height: auto;
        right: -20vw;
        top: -8vw;
      }
      .role-4 .roleIdx {
        width: 1641px;
        height: auto;
        right: -21vw;
        top: -39vw;
      }
      // 头像icon
      .swiper-pagination-role {
        transition: all 0.5s;
        top: 39vw;
        left: 10.5vw;
        height: 123px;
        display: flex;
        align-items: center;
        gap: 0.5vw;

        .my-bullet {
          display: flex;
          justify-content: center;
          width: 104px;
          height: 135px;

          i {
            display: block;
            width: 100%;
            height: 100%;
            z-index: 1;
          }
        }
        .swiper-pagination-bullet-active {
          background-color: transparent;
        }
        .my-bullet0 i {
          background: url("../../assets/img/layer4/1.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet0.swiper-pagination-bullet-active i {
          background: url("../../assets/img/layer4/1-active.png") no-repeat;
          background-size: 100% 100%;
        }
        .my-bullet1 i {
          background: url("../../assets/img/layer4/2.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet1.swiper-pagination-bullet-active i {
          background: url("../../assets/img/layer4/2-active.png") no-repeat;
          background-size: 100% 100%;
        }
        .my-bullet2 i {
          background: url("../../assets/img/layer4/3.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet2.swiper-pagination-bullet-active i {
          background: url("../../assets/img/layer4/3-active.png") no-repeat;
          background-size: 100% 100%;
        }
        .my-bullet3 i {
          background: url("../../assets/img/layer4/4.png") no-repeat;
          background-size: 100% 100%;
        }

        .my-bullet3.swiper-pagination-bullet-active i {
          background: url("../../assets/img/layer4/4-active.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer4 {
   .cnt{
        .bt {
          margin: 6vw 0 0 8vw !important;
        }
        .role-info {
          margin: 12vw 0 0 2vw !important;

        }
        .swiper-pagination-role {
          top: 43vw !important;
        }
        .swiper-button-prev ,
        .swiper-button-next {
          top: 47.5vw !important;
        }
   } 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer4.vue